import * as request from "src/utils/request";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
// const scope = 'OnePlatform';
// const roPluralName = 'email';
const scope = "AI";
const roPluralName = "aiRequests";

export async function getCloudAttachment(id: string) {
  request.changeBaseUrl(publicRuntimeConfig.AIR_LCL_COMMON_BFF_URL);
  return request.get(`invoicing/api/internal/cloudAttachments/${id}`);
}

// AI File Upload APIs
export function getUploadUrl(fileName: string) {
  request.changeBaseUrl(publicRuntimeConfig.AIR_LCL_COMMON_BFF_URL);
  const params = {
    scope: scope,
    roPluralName: roPluralName,
    scenario: "STORE",
    fileName: fileName,
  };
  return request.get(
    `invoicing/api/internal/cloudAttachments/accessUrl?scope=${params.scope}&roPluralName=${params.roPluralName}&scenario=${params.scenario}&fileName=${params.fileName}`
  );
}

export function putUpload(url: string, data: File) {
  request.changeBaseUrl(publicRuntimeConfig.AIR_LCL_COMMON_BFF_URL);
  return request.putUpload(url, data as any);
}

export function putAttachments(fileName: string, cloudStorageUrl: string) {
  request.changeBaseUrl(publicRuntimeConfig.AIR_LCL_COMMON_BFF_URL);
  const params = {
    scope: scope,
    roPluralName: roPluralName,
    scenario: "STORE",
    fileName: fileName,
    cloudStorageUrl: cloudStorageUrl,
  };
  return request.post(`invoicing/api/internal/cloudAttachments`, params);
}
